export const CouponCodeModes = {
  SINGLE: 'single',
  MULTI: 'multi'
};

export const COUPON_MAX_CODE_COUNT = 5000;
export const MAX_CODE_GEN_PER_CLICK = 500;

export const durationConstat = [
  { key: 'year', value: 'years' },
  { key: 'month', value: 'months' },
  { key: 'days', value: 'days' },
  { key: 'hours', value: 'hours' },
  { key: 'minutes', value: 'minutes' }
];

export const ExpireModes = {
  NONE: 'none',
  DURATION: 'duration',
  FIXED: 'fixed'
};

// What a coupon discounts: the cart items or only the shipping fee.
export const DiscountTargets = {
  ITEMS: 'items',
  SHIPPING: 'shipping'
};
